import { ExpertMatch } from '../_models/expertMatch';
import { EXPERTS } from './mock-expert';

export const EXPERT_MATCH: ExpertMatch[] = [
  { id : 1, matching_rate: 90, expert : EXPERTS[0] },
  { id : 2, matching_rate: 80, expert : EXPERTS[1] }
];